import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "inviteCsvMappingForm" }
const _hoisted_2 = {
  key: 0,
  class: "alertBox"
}
const _hoisted_3 = { class: "mappingGrid" }
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 0,
  class: "req",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 0,
  class: "error mappingSummary"
}
const _hoisted_7 = {
  key: 1,
  class: "mappingSummary mappingSummaryWarning"
}
const _hoisted_8 = { class: "mappingActions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_multiselect = _resolveComponent("vue-multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mappingIntro" }, " For each invite field our system expects, choose the column from your uploaded CSV that provides it. Fields you leave unmapped are left blank. This lets you load a CSV in any column layout — the mapping applies to this upload only. ", -1)),
    (_ctx.headers.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " No columns were read from the uploaded CSV. Re-select a file with a header row. "))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnSets, (columnSet, setIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: setIndex,
                class: "mappingColumn"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnSet, (col) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: col.header,
                    class: _normalizeClass(["mappingRow", _ctx.highlightClass(col)])
                  }, [
                    _createElementVNode("label", {
                      class: "mappingFieldLabel",
                      for: 'map_' + col.key
                    }, [
                      _createTextVNode(_toDisplayString(col.label), 1),
                      (col.required)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_4),
                    _createVNode(_component_vue_multiselect, {
                      id: 'map_' + col.key,
                      modelValue: _ctx.selections[col.header],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.selections[col.header]) = $event),
                      options: _ctx.availableHeaders(col),
                      "track-by": "key",
                      label: "original",
                      "show-labels": false,
                      "allow-empty": true,
                      placeholder: "— not mapped —"
                    }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "options"])
                  ], 2))
                }), 128))
              ]))
            }), 128))
          ]),
          (_ctx.validationAttempted && _ctx.missingRequired.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Map every required field before the CSV can be loaded: " + _toDisplayString(_ctx.missingRequired.map(c => c.label).join(', ')) + ". ", 1))
            : (_ctx.validationAttempted && _ctx.missingOptional.length > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Optional fields highlighted in yellow are not mapped and will be left blank. "))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
            }, "Validate Mappings")
          ])
        ], 64))
  ]))
}